 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import TOC from '@/components/toc'
 import A_CHAPTER1THELONELYKING from '@/components/0_chapter1thelonelyking'
 import A_CHAPTER2MURDERONTHETABLE from '@/components/1_chapter2murderonthetable'
 import A_CHAPTER3WEIRDCAPTAIN from '@/components/2_chapter3weirdcaptain'
 import A_CHAPTER4PERFECTSOLUTION from '@/components/3_chapter4perfectsolution'
 import A_CHAPTER5TRUEMURDERMETHOD from '@/components/4_chapter5truemurdermethod'
 import A_CHAPTER6THEPOWERBEHINDIT from '@/components/5_chapter6thepowerbehindit'
 import A_CHAPTER7JADEPENDANT from '@/components/6_chapter7jadependant'
 import A_CHAPTER8SHIFTSTUDENT from '@/components/7_chapter8shiftstudent'
 import A_CHAPTER9AFFECTEDMILKTEASHOP from '@/components/8_chapter9affectedmilkteashop'
 import A_CHAPTER10BLACKNIGHTCONSPIRACY from '@/components/9_chapter10blacknightconspiracy'
 import A0_CHAPTER11CHIP from '@/components/10_chapter11chip'
 import A1_CHAPTER12DREAM from '@/components/11_chapter12dream'
 import A2_CHAPTER13JADEPENDANT from '@/components/12_chapter13jadependant'
 import A3_CHAPTER14THEORIGINOFJADEPENDANT from '@/components/13_chapter14theoriginofjadependant'
 import A4_CHAPTER15TWOPEOPLEDIARRHOEA from '@/components/14_chapter15twopeoplediarrhoea'
 import A5_CHAPTER16MANDATEOFTHEPRESIDENT from '@/components/15_chapter16mandateofthepresident'
 import A6_CHAPTER17UNEXPECTEDIDENTITY from '@/components/16_chapter17unexpectedidentity'
 import A7_CHAPTER18GOBACKTOTHEMILKTEASHOP from '@/components/17_chapter18gobacktothemilkteashop'
 import A8_CHAPTER19ZHAOYAQING from '@/components/18_chapter19zhaoyaqing'
 import A9_CHAPTER20TOHITAWALLISTORETREATINORDERTOADVANCE from '@/components/19_chapter20tohitawallistoretreatinordertoadvance'
 import A0_CHAPTER21EXPENSE from '@/components/20_chapter21expense'
 import A1_CHAPTER22RECOLLECTION from '@/components/21_chapter22recollection'
 import A2_CHAPTER23TROUBLEWITHZHAOYATING from '@/components/22_chapter23troublewithzhaoyating'
 import A3_CHAPTER24ZHAOGROUPSDESTRUCTION from '@/components/23_chapter24zhaogroupsdestruction'
 import A4_CHAPTER25YANRUXUANSMETHODS from '@/components/24_chapter25yanruxuansmethods'
 import A5_CHAPTER26MOLU from '@/components/25_chapter26molu'
 import A6_CHAPTER27CROWN from '@/components/26_chapter27crown'
 import A7_CHAPTER28PASTLIFE1 from '@/components/27_chapter28pastlife1'
 import A8_CHAPTER29PASTLIFE2 from '@/components/28_chapter29pastlife2'
 import A9_CHAPTER30PASTLIFE3 from '@/components/29_chapter30pastlife3'
 import A0_CHAPTER31PASTLIFE4 from '@/components/30_chapter31pastlife4'
 import A1_CHAPTER32PASTLIFE5 from '@/components/31_chapter32pastlife5'
 import A2_CHAPTER33ITTURNEDOUTTOBEADREAM from '@/components/32_chapter33itturnedouttobeadream'
 import A3_CHAPTER34CONFESSION from '@/components/33_chapter34confession'
 import A4_CHAPTER35TOGETHER from '@/components/34_chapter35together'
 import A5_CHAPTER36CUES from '@/components/35_chapter36cues'
 import A6_CHAPTER37FOUR from '@/components/36_chapter37four'
 import A7_CHAPTER38CHOOSETOHIDE from '@/components/37_chapter38choosetohide'
 import A8_CHAPTER39THENEWSITUATIONINTHECLASS from '@/components/38_chapter39thenewsituationintheclass'
 import A9_CHAPTER40CLASSMATE from '@/components/39_chapter40classmate'
 import A0_CHAPTER41PLAYGROUND from '@/components/40_chapter41playground'
 import A1_CHAPTER42RUSE from '@/components/41_chapter42ruse'
 import A2_CHAPTER43CENSURE from '@/components/42_chapter43censure'
 import A3_CHAPTER44SCOLDING from '@/components/43_chapter44scolding'
 import A4_CHAPTER45DISCIPLE from '@/components/44_chapter45disciple'
 import A5_CHAPTER46CARBUNCLE from '@/components/45_chapter46carbuncle'
 import A6_CHAPTER47GANGANNIHILATE from '@/components/46_chapter47gangannihilate'
 import A7_CHAPTER48FINDMASTER from '@/components/47_chapter48findmaster'
 import A8_CHAPTER49DEPARTURE from '@/components/48_chapter49departure'
 import A9_CHAPTER50DECISION from '@/components/49_chapter50decision'
 import A0_CHAPTER51AWAKENING from '@/components/50_chapter51awakening'
 import A1_CHAPTER52SNOWDROP from '@/components/51_chapter52snowdrop'
 import A2_CHAPTER53RAINWATER from '@/components/52_chapter53rainwater'
 import A3_CHAPTER54AWAY from '@/components/53_chapter54away'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/0_chapter1thelonelyking",
 			"name" : "0_chapter1thelonelyking",
 			"component" : A_CHAPTER1THELONELYKING
 		},
 		{
 			"path" : "/1_chapter2murderonthetable",
 			"name" : "1_chapter2murderonthetable",
 			"component" : A_CHAPTER2MURDERONTHETABLE
 		},
 		{
 			"path" : "/2_chapter3weirdcaptain",
 			"name" : "2_chapter3weirdcaptain",
 			"component" : A_CHAPTER3WEIRDCAPTAIN
 		},
 		{
 			"path" : "/3_chapter4perfectsolution",
 			"name" : "3_chapter4perfectsolution",
 			"component" : A_CHAPTER4PERFECTSOLUTION
 		},
 		{
 			"path" : "/4_chapter5truemurdermethod",
 			"name" : "4_chapter5truemurdermethod",
 			"component" : A_CHAPTER5TRUEMURDERMETHOD
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js